import { call, put, takeEvery, takeLatest, delay } from "redux-saga/effects"

// Login Redux States
import { FETCH_CONST_DETAILS, LOGIN_USER, LOGOUT_USER, SOCIAL_LOGIN } from "./actionTypes"
import { apiError, loginSuccess, loginFailed, SetConstDetails, logoutUser, logoutUserSuccess, logoutUserFailed } from "./actions"
import { LystfaceConstDetails, LystfaceLogin, LystfaceLogout } from "../../../helpers/lystface_helper"
import axios from "axios"
import { axiosApi } from "../../../helpers/api_helper"
import Cookies from 'js-cookie'
import { resetAccountSetting } from "../../menu/application/actions"

//Include Both Helper File with needed methods

function* loginUser({ payload: { user, history } }) {
  try {
    const UserLoggedIn = yield call(LystfaceLogin, user)
    if (UserLoggedIn.responseCode == false) {
      yield put(loginFailed({ loginErrorMessage: UserLoggedIn.responseMessage, loginErrorType: UserLoggedIn?.response?.type, user: user?.email, userpswd: user?.pwd }))
    } else {
      yield put(loginSuccess({ user: user.email, twoFactor: UserLoggedIn?.response?.twoFactor, cmp_phone: UserLoggedIn?.response?.cmp_phone, cmp_phone_code: UserLoggedIn?.response?.cid, dailcode: UserLoggedIn?.response?.cmp_phone_code, loginErrorType: UserLoggedIn?.response?.type, loginErrorMessage: UserLoggedIn?.response?.type === "email_not_verfied" ? UserLoggedIn.responseMessage : null, loginError: false }))
      console.log('process.env.NODE_ENV', process.env.NODE_ENV)
      if (!UserLoggedIn?.response?.twoFactor && UserLoggedIn?.response?.type !== "email_not_verfied") {
        Cookies.set("SESSION_ID", true)
        if (history) {
          history("/dashboard")

        }

      }
    }
  } catch (error) {
    console.log(error)
    yield put(loginFailed({ loginErrorMessage: 'There was an error logging in,please try again later!', loginErrorType: null }))

  }
}

function* logoutUserSaga({ payload: { history, timeout } }) {
  try {
    const UserLoggedOut = yield call(LystfaceLogout)
    if (UserLoggedOut.responseCode) {
      yield put(logoutUserSuccess({ timeout: timeout ? timeout : false }))
      history("/login")
      Cookies.remove("SESSION_ID")
      Cookies.remove("USG_APP_ID")
      Cookies.remove("RESEND_ID")
    }
    else {
      yield put(logoutUserFailed({ responseMessage: UserLoggedOut?.responseMessage }))

    }

  } catch (error) {
    console.log('error', error)
    yield put(logoutUserFailed({ responseMessage: 'There was an error logging out, please try again later!' }))
  }
}

function* socialLogin({ payload: { data, history, type } }) {
  try {
    history("/dashboard")
  } catch (error) { }
}

function* getConstDetails({ payload: { history } }) {
  try {
    const Response = yield call(LystfaceConstDetails)
    let data = {
      ...Response?.response || {},
      billing_setup: Response?.response?.billingInfo,
      card_setup: Response?.response?.payInfo,
      loading: false,
      success: Response?.responseCode

    }
    if (Response?.responseCode) {
      yield put(SetConstDetails(data))
    } else {
      yield put(logoutUser({ history: history, timeout: true }))
      yield put(SetConstDetails(data))

    }
  } catch (error) {
    console.log('error', error)
    yield put(SetConstDetails({ loading: false, success: 0 }))
    yield put(logoutUser({ history: history, timeout: true }))

  }
}

function* authSaga() {
  yield takeEvery(LOGIN_USER, loginUser)
  yield takeLatest(SOCIAL_LOGIN, socialLogin)
  yield takeEvery(LOGOUT_USER, logoutUserSaga)
  yield takeEvery(FETCH_CONST_DETAILS, getConstDetails)
}

export default authSaga
